import type {FC, ReactNode} from 'react'
import {Paper} from '@mui/material'

interface Props {
  children: ReactNode
}

const SystemBubble: FC<Props> = ({children}) => {
  return (
    <Paper
      sx={{
        p: 1,
        maxWidth: '75%',
        alignSelf: 'flex-start',
        borderRadius: 2,
        bgcolor: 'background.paper',
        color: 'text.secondary',
        border: (t) => `1px dashed ${t.palette.divider}`,
      }}
    >
      {children}
    </Paper>
  )
}
export default SystemBubble
